import React from "react";
import Pager from "../pager/Pager";
import ResourceState from "../resourceState/ResourceState";
import { displayMoney } from "../CallLeadDetails.utils";
import { transactionAmountClass } from "./Transactions.utils";

const Transactions = ({ resource, formatDate, onPage }) => (
  <ResourceState resource={resource} emptyText="No claim transactions found.">
    <div className="cw-table-wrap" tabIndex="0" aria-label="Claim transactions">
      <table className="cw-table cw-history-table">
        <thead>
          <tr><th>Date</th><th>Description</th><th>Type</th><th>Amount</th></tr>
        </thead>
        <tbody>
          {resource.data.data.map((item, index) => (
            <tr key={(item.order_id || "transaction") + "-" + index}>
              <td>{formatDate(item.created_at_api || item.created_at, true)}</td>
              <td>{item.note_title || item.note_description || "Claim balance transaction"}</td>
              <td>{item.transaction_type || "—"}</td>
              <td className={transactionAmountClass(item.transaction_type)}>
                {displayMoney(item.points)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <Pager page={resource.data} loading={resource.loading} onPage={onPage} />
  </ResourceState>
);

export default Transactions;
